<template>
    <div class="customer-search">
        <loader class="panel-loader" v-if="!isDataLoaded && !hasError"></loader>
        <div class="error-container alert alert-danger" v-if="hasError">
            {{error}}
        </div>
        <div v-if="isDataLoaded && !isEditing">
            <table class="table table-striped">
                <thead>
                    <tr><th>Id</th><th>Name</th><th></th></tr>
                </thead>
                <tbody>
                    <tr v-for="result in results">
                        <td>{{result.id}}</td>
                        <td>{{result.name}}</td>
                        <td>
                            <span class="glyphicon glyphicon-pencil" v-on:click="edit(result.id)"></span>
                            <span class="glyphicon glyphicon-trash" v-on:click="remove(result.id)"></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="isDataLoaded && isEditing">
            <span class="close glyphicon glyphicon-remove" v-on:click="cancelEdit()"></span>
            <h4>Edit {{currentSearch.name}}</h4>
            <div class="form-group customer-search-query-wrapper">
                <label>Name</label>
                <input class="form-control" v-model="currentSearch.name" />
            </div>
            <div class="form-group customer-search-query-wrapper">
                <label>Description</label>
                <text-area-component class="form-control" v-model="currentSearch.description" />
            </div>
            <div class="form-group customer-search-query-wrapper">
                <component v-bind:is="searchMode" v-model="currentSearch.parameters" :searchSpec="queryBuilderSpec" :class="searchClass" />
            </div>
            <div class="form-group customer-search-query-wrapper">
                <toggle-switch v-model="currentSearch.shared">Share with my team</toggle-switch>
            </div>
            <div class="form-group">
                <button class="search-mode btn btn-primary col-xs-3" v-on:click="toggleMode()">{{toggleTo}}</button>
                <button class="search-action btn btn-primary col-xs-3 pull-right" v-on:click="save()">Save</button>
                <button class="search-action btn btn-primary col-xs-3 pull-right" v-on:click="testSearch()">Test</button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import QueryBuilder from '@/components/search/QueryBuilder'
    import TextAreaComponent from '@/components/TextAreaComponent'
    import ToggleSwitch from '@/components/ToggleSwitch'
    import Loader from '@/components/Loader'

    export default {
        props: ['contentSource'],
        name: 'SavedSearches',
        components: {
            QueryBuilder,
            TextAreaComponent,
            ToggleSwitch,
            Loader
        },
        data () {
            return {
                content: false,
                error: null,
                current: 0,
                endpoints: null,
                currentSearch: {},
                queryBuilderSpec: {},
                results: null
            }
        },
        computed: {
            isDataLoaded () {
                return this.content || false
            },
            hasError () {
                return this.error !== undefined && this.error !== null
            },
            isEditing () {
                return this.current > 0
            },
            showAdvancedSearch () {
                return (typeof this.currentSearch.parameters === 'object')
            },
            searchMode () {
                return this.showAdvancedSearch ? 'query-builder' : 'text-area-component'
            },
            searchClass () {
                return this.showAdvancedSearch ? '' : 'form-control'
            },
            toggleTo () {
                return this.showAdvancedSearch ? 'Basic' : 'Query Builder'
            }
        },
        methods: {
            getData () {
                const self = this
                return this.post(self, this.contentSource, {edit: true}, 'save', function (response) {
                    self.setData(self, response.data)
                })
            },
            setData (self, data) {
                self.content = true
                self.results = data.content.data || null
                self.endpoints = data.endpoints || {}
                self.queryBuilderSpec = data.queryBuilderSpec || {}
            },
            toggleMode () {
                if (this.currentSearch.parameters === '' || Object.keys(this.currentSearch.parameters).length === 0 || window.confirm('Changing modes will discard your current search. Continue?')) {
                    this.currentSearch.parameters = this.showAdvancedSearch ? '' : {}
                }
            },
            edit (id) {
                const self = this
                return this.post(self, this.endpoints.edit, {id: id}, 'save', function (response) {
                    self.currentSearch = response.data.currentSearch
                    self.current = id
                })
            },
            save () {
                let query = {
                    id: this.current,
                    name: this.currentSearch.name,
                    description: this.currentSearch.description,
                    parameters: typeof this.currentSearch.parameters === 'string' ? this.currentSearch.parameters : JSON.stringify(this.currentSearch.parameters),
                    shared: this.currentSearch.shared ? 1 : 0
                }
                const self = this

                return this.post(self, this.endpoints.save, query, 'save', function (response) {
                    let updated = self.results.findIndex(x => x.id === self.current)
                    self.results[updated].name = self.currentSearch.name
                    self.current = 0
                })
            },
            cancelEdit () {
                this.current = 0
            },
            remove (id) {
                const self = this
                return this.post(self, this.endpoints.delete, {id: id}, 'delete', function (response) { self.results = self.results.filter(data => data.id !== id) })
            },
            post (self, endpoint, data, action, callback) {
                this.error = null
                this.content = false

                if (endpoint !== undefined) {
                    return axios.post(endpoint, querystring.stringify(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                        .then(function (response) {
                            if (!response.data.result) {
                                self.error = response.data.message || 'An unknown error has occurred'
                            } else {
                                callback(response)
                            }

                            self.content = true
                        })
                        .catch((error) => {
                            if (error instanceof Error) {
                                self.error = error.message || 'An unknown error has occurred'
                                self.content = true
                            }
                        })
                } else {
                    self.error = 'Cannot complete ' + action + ' request'
                    self.content = true
                }
            }
        },
        created () {
            if (this.contentSource !== undefined && this.contentSource !== null) {
                this.getData({})
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SavedSearches.vue?051c054a